import { IResponse, IResponsePagination, IResponseList } from '@/types/common';
import {
  ICreateArticleRequest,
  IGetListArticleRequest,
  IUpdateArticleRequest,
} from '@/types/request/article';
import { IGetListArticleResponse } from '@/types/response/article';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';
import { IBanner } from '@/types/response';

class Article {
  getList = (
    params: IGetListArticleRequest,
  ): Promise<IResponsePagination<IGetListArticleResponse>> => {
    return axiosClient.get(ENDPOINT.ARTICLE.GET_LIST, { params });
  };

  delete = (id: number) => {
    return axiosClient.delete(
      ENDPOINT.ARTICLE.DELETE.replace(':id', String(id)),
    );
  };

  create = (body: ICreateArticleRequest): Promise<IResponse<any>> => {
    return axiosClient.post(ENDPOINT.ARTICLE.CREATE, body);
  };

  getDetail = (id: number): Promise<IResponse<any>> => {
    return axiosClient.get(
      ENDPOINT.ARTICLE.GET_DETAIL.replace(':id', String(id)),
    );
  };

  update = (
    data: IUpdateArticleRequest,
    id: number,
  ): Promise<IResponse<any>> => {
    return axiosClient.put(
      ENDPOINT.ARTICLE.UPDATE.replace(':id', String(id)),
      data,
    );
  };

  getCategories = (): Promise<IResponseList<any>> => {
    return axiosClient.get(ENDPOINT.ARTICLE.GET_CATEGORIES);
  };

  getTags = (): Promise<IResponseList<any>> => {
    return axiosClient.get(ENDPOINT.ARTICLE.GET_TAGS);
  };

  getOffers = (): Promise<IResponseList<any>> => {
    return axiosClient.get(ENDPOINT.ARTICLE.GET_OFFERS);
  };

  getCheckboxList = ({
    bannerId,
    fukumaruQuizId,
    chatFukumaruId,
  }: {
    bannerId?: number | string;
    fukumaruQuizId?: number | string;
    chatFukumaruId?: number | string;
  }): Promise<IResponseList<IBanner>> => {
    return axiosClient.get(ENDPOINT.ARTICLE.GET_CHECKBOX_LIST, {
      params: { bannerId, fukumaruQuizId, chatFukumaruId },
    });
  };
}

export const ArticleService = new Article();
